import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
  type OnDestroy,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatNativeDateModule, MatOption } from '@angular/material/core';
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerModule,
  MatDatepickerToggle,
} from '@angular/material/datepicker';
import {
  MatFormField,
  MatLabel,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { ChartData, ChartOptions, type ChartConfiguration } from 'chart.js';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiServiceService } from '../api-service.service';
import { CommonGraphComponent } from '../common-component-graph/common-component-graph.component';
import { CommonInfoTooltipComponent } from '../common-component-info-tooltip/common-component-info-tooltip.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { ticketStatusKpiInfo } from '../shared/info-text/ticket-status-kpi.info';
import { buildChartTheme } from '../shared/utils/chart-theme.util';
import { IndianNumberPipe } from '../pipes/indian-number.pipe';
import { ticketDashboardGraphInfo } from './ticket-dashboard-page.info';

@Component({
  selector: 'app-ticket-dashboard-page',
  templateUrl: './ticket-dashboard-page.component.html',
  styleUrls: ['./ticket-dashboard-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    MatFormField,
    MatIcon,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatSelect,
    NgxMatSelectSearchModule,
    MatOption,
    DatePipe,
    MatTooltip,
    MatDatepickerModule,
    MatNativeDateModule,
    CommonSearchComponent,
    CommonPaginationComponent,
    CommonGraphComponent,
    CommonInfoTooltipComponent,
    IndianNumberPipe,
  ],
})
export class TicketDashboardPageComponent implements OnInit, OnDestroy {
  projectName = environment.projectName;
  @ViewChild('tableContainer') MyProp!: ElementRef;

  size = 10;
  page = 1;
  totalLength = 0;
  private spinnerCount = 0;

  listOfData = [];
  simplifiedTicketStatus: Record<string, string> = {
    STS_CO_01: 'Not Assigned',
    STS_CO_02: 'Assigned',
    STS_CO_03: 'Started',
    STS_CO_04: 'In Queue',
    STS_CO_05: 'In Progress',
    STS_CO_06: 'Completed',
    STS_CO_07: 'On Hold Due to Vehicle Not Available',
    STS_CO_08: 'On Hold Due to Ignition Not ON',
    STS_CO_09: 'On Hold Due to GSM Network Not Available',
    STS_CO_10: 'On Hold Due to Invalid GPS',
    STS_CO_11: 'On Hold Due To Vahan Portal Down',
    STS_CO_12: 'On Hold Due to Data not Available on VAHAN',
    STS_CO_13: 'On Hold Due to Backend Portal Down',
    STS_CO_14: 'On Hold Due to Panic Event Not Confirmed',
    STS_CO_15: 'On Hold Due to OTP not being received',
    STS_CO_16: 'On Hold Due to Live Location Pending from Backend',
    STS_CO_17: 'On Hold Due to Waiting for RTO Approval',
    STS_CO_18: 'Ticket Completed and Closed',
    STS_CO_19: 'Ticket Generated but Data Not Received from CRM',
    STS_CO_20: 'Ticket Cancelled Due to Change Request Device Change',
    STS_CO_21: 'Ticket Cancelled Due to Change Request Vehicle Owner Change',
    STS_CO_22: 'Ticket Cancelled Due to Change Request RTO or State Change',
    STS_CO_23: 'Ticket Cancelled as per Request',
    STS_CO_24: 'Ticket Cancelled Due to Invoice Cancelled',
    STS_CO_25: 'Change required from CRM',
    STS_CO_26: 'Other',
    STS_CO_28: 'On Hold Due to Non-Working Hours',
    STS_CO_29: 'On Hold Due to SIM Validity Issue',
    STS_CO_30: 'Ticket Suspended Due to Customer Not Responding',
    STS_CO_31: 'On Hold Due to No Response from Customer',
    STS_CO_32: 'On Hold Due to Customer Details Mismatch',
  };

  allCount = 0;
  completed = 0;
  cancelled = 0;
  inProgress = 0;
  onHold = 0;

  // Plain-language explanations shown via the info icon on each KPI card and
  // graph, kept in their own files (imported above) for isolation from this
  // component's logic. kpiInfo is shared with the My AIS140 Tickets list,
  // which shows the same KPI cards backed by the same endpoint.
  kpiInfo = ticketStatusKpiInfo;
  graphInfo = ticketDashboardGraphInfo;

  table_title = 'All';
  kpiCardSelected = 'ALL';

  ticketCompletedAtFromDate = '';
  ticketCompletedAtToDate = '';
  fromDate = '';
  toDate = '';
  listOfState = [];
  filteredListOfState = [];
  stateNameFilterCtrl: FormControl = new FormControl();
  listOfDealers = [];
  filteredListOfDealers = [];
  dealerCodeFilterCtrl: FormControl = new FormControl();
  listOfAssignedUser = [];
  filteredListOfAssignedUser = [];
  userNameFilterCtrl: FormControl = new FormControl();
  initiatedByList = [
    {
      initiatedByName: 'TML CRM & FE',
      initiatedByValue: 'crm',
    },
    {
      initiatedByName: 'Institutional Sales AEPL',
      initiatedByValue: 'inst',
    },
  ];
  deviceTypeList = [
    {
      deviceTypeName: 'TCU2G',
      deviceTypeValue: 'ATCU2G',
    },
    {
      deviceTypeName: 'TCU4G',
      deviceTypeValue: 'ATCU4G',
    },
  ];
  listOfTicketStatus = [
    {
      statusCode: 'STS_CO_01',
      status: 'Not Assigned',
    },
    {
      statusCode: 'STS_CO_02',
      status: 'Assigned',
    },
    {
      statusCode: 'STS_CO_03',
      status: 'Started',
    },
    {
      statusCode: 'STS_CO_04',
      status: 'In Queue',
    },
    {
      statusCode: 'STS_CO_05',
      status: 'In Progress',
    },
    {
      statusCode: 'STS_CO_06',
      status: 'Completed',
    },
    {
      statusCode: 'STS_CO_07',
      status: 'On Hold Due to Vehicle Not Available',
    },
    {
      statusCode: 'STS_CO_08',
      status: 'On Hold Due to Ignition Not ON',
    },
    {
      statusCode: 'STS_CO_09',
      status: 'On Hold Due to GSM Network Not Available',
    },
    {
      statusCode: 'STS_CO_10',
      status: 'On Hold Due to Invalid GPS',
    },
    {
      statusCode: 'STS_CO_11',
      status: 'On Hold Due To Vahan Portal Down',
    },
    {
      statusCode: 'STS_CO_12',
      status: 'On Hold Due to Data not Available on VAHAN',
    },
    {
      statusCode: 'STS_CO_13',
      status: 'On Hold Due to Backend Portal Down',
    },
    {
      statusCode: 'STS_CO_14',
      status: 'On Hold Due to Panic Event Not Confirmed',
    },
    {
      statusCode: 'STS_CO_15',
      status: 'On Hold Due to OTP not being received',
    },
    {
      statusCode: 'STS_CO_16',
      status: 'On Hold Due to Live Location Pending from Backend',
    },
    {
      statusCode: 'STS_CO_17',
      status: 'On Hold Due to Waiting for RTO Approval',
    },
    {
      statusCode: 'STS_CO_18',
      status: 'Ticket Completed and Closed',
    },
    {
      statusCode: 'STS_CO_19',
      status: 'Ticket Generated but Data Not Received from CRM',
    },
    {
      statusCode: 'STS_CO_20',
      status: 'Ticket Cancelled Due to Change Request Device Change',
    },
    {
      statusCode: 'STS_CO_21',
      status: 'Ticket Cancelled Due to Change Request Vehicle Owner Change',
    },
    {
      statusCode: 'STS_CO_22',
      status: 'Ticket Cancelled Due to Change Request RTO or State Change',
    },
    {
      statusCode: 'STS_CO_23',
      status: 'Ticket Cancelled as per Request',
    },
    {
      statusCode: 'STS_CO_24',
      status: 'Ticket Cancelled Due to Invoice Cancelled',
    },
    {
      statusCode: 'STS_CO_25',
      status: 'Change required from CRM',
    },
    {
      statusCode: 'STS_CO_26',
      status: 'Other',
    },
    {
      statusCode: 'STS_CO_28',
      status: 'On Hold Due to Non-Working Hours',
    },
    {
      statusCode: 'STS_CO_29',
      status: 'On Hold Due to SIM Validity Issue',
    },
    {
      statusCode: 'STS_CO_30',
      status: 'Ticket Suspended Due to Customer Not Responding',
    },
    {
      statusCode: 'STS_CO_31',
      status: 'On Hold Due to No Response from Customer',
    },
    {
      statusCode: 'STS_CO_32',
      status: 'On Hold Due to Customer Details Mismatch',
    },
  ];

  kpiStatusMap = {
    ALL: null,

    PRO: [
      'STS_CO_01',
      'STS_CO_02',
      'STS_CO_03',
      'STS_CO_04',
      'STS_CO_05',
      'STS_CO_06',
    ],

    HOLD: [
      'STS_CO_07',
      'STS_CO_08',
      'STS_CO_09',
      'STS_CO_10',
      'STS_CO_11',
      'STS_CO_12',
      'STS_CO_13',
      'STS_CO_14',
      'STS_CO_15',
      'STS_CO_16',
      'STS_CO_17',
      'STS_CO_19',
      'STS_CO_25',
      'STS_CO_26',
      'STS_CO_28',
      'STS_CO_29',
      'STS_CO_30',
      'STS_CO_31',
      'STS_CO_32',
    ],

    COM: ['STS_CO_18'],

    CAN: ['STS_CO_20', 'STS_CO_21', 'STS_CO_22', 'STS_CO_23', 'STS_CO_24'],
  };

  tatTypeList = [
    {
      tatTypeName: 'LESS_THAN_4',
      tatTypeValue: 'LESS_THAN_4',
    },
    {
      tatTypeName: 'LESS_THAN_10',
      tatTypeValue: 'LESS_THAN_10',
    },
    {
      tatTypeName: 'MORE_THAN_10',
      tatTypeValue: 'MORE_THAN_10',
    },
    {
      tatTypeName: 'IN_PROGRESS',
      tatTypeValue: 'IN_PROGRESS',
    },
    {
      tatTypeName: 'ON_HOLD',
      tatTypeValue: 'ON_HOLD',
    },
    {
      tatTypeName: 'ON_HOLD_DUE_TO_RTO_APPROVAL',
      tatTypeValue: 'ON_HOLD_DUE_TO_RTO_APPROVAL',
    },
    {
      tatTypeName: 'ON_HOLD_DUE_TO_SUSPENDED_OR_OTHER',
      tatTypeValue: 'ON_HOLD_DUE_TO_SUSPENDED_OR_OTHER',
    },
  ];

  filteredListOfTicketStatus = [];
  ticketStatusFilterCtrl: FormControl = new FormControl();
  private _onDestroy = new Subject<void>();
  maxDate: string = new Date().toISOString().split('T')[0];

  assignTo = '';
  state = '';
  dealerCode = '';
  initiatedBy = '';
  ticketStatusFilter = '';
  deviceType = '';
  tatType = '';
  ticketDashboardSearch = '';

  reportsDashboardForm: FormGroup = this.formBuilder.group({});
  ticketDashboardSearchForm: FormGroup = this.formBuilder.group({});

  monthWiseChartData!: ChartData<'line'>;
  tatBucketChartData!: ChartData<'bar'>;
  tatHoldReasonChartData!: ChartData<'bar'>;
  stateChartData!: ChartData<'bar'>;
  userPerformanceChartData!: ChartData<'bar'>;
  deviceModelChartData!: ChartData<'pie'>;

  barChartOptions!: ChartConfiguration<'bar'>['options'];
  lineChartOptions!: ChartConfiguration<'line'>['options'];
  pieChartOptions!: ChartOptions<'pie'>;

  // Subject to unsubscribe from observables
  userPermission = [];

  ticketTATTimeReportView = false;
  ticketDashboardView = false;
  MyActivationsViewMasterAccess = false;

  isDownloading = false;

  // storage listener for cross-tab sync
  private storageListener = (event: StorageEvent) => {
    if (event.key === 'downloadInProgress') {
      this.isDownloading = event.newValue === 'true';
    }
  };

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.applyChartTheme();
    this.checkPermission();
    this.setTicketDashboardForm();
    this.getTicketDashboardGraphData();
    this.syncInitialDownloadState();
    if (this.ticketDashboardView) {
      this.fetchData(this.kpiCardSelected);
      this.getAllCount();
    }
  }

  @HostListener('window:themeChanged')
  onThemeChanged() {
    this.applyChartTheme();
  }

  applyChartTheme() {
    this.barChartOptions = buildChartTheme<'bar'>();

    this.lineChartOptions = buildChartTheme<'line'>();

    this.pieChartOptions = {
      responsive: true,
      maintainAspectRatio: false,

      plugins: {
        legend: {
          labels: {
            color: getComputedStyle(document.body)
              .getPropertyValue('--theme-text')
              .trim(),
          },
        },
      },
    };
  }

  // Cleanup subscriptions
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'Ticket Dashboard' && element.view === false) {
          this.navigateBack();
        }
        if (element.pageName === 'Ticket Dashboard' && element.view === true) {
          this.ticketDashboardView = true;
        }
        if (
          element.pageName === 'Ticket TAT Time Report' &&
          element.view === true
        ) {
          this.ticketTATTimeReportView = true;
        }
        if (
          element.pageName === 'My AIS 140 Tickets Master Access' &&
          element.view === true
        ) {
          this.MyActivationsViewMasterAccess = true;
        }
      }
    );
  }

  syncInitialDownloadState() {
    // sync initial download state across tabs
    this.isDownloading = localStorage.getItem('downloadInProgress') === 'true';
    window.addEventListener('storage', this.storageListener);
  }

  setTicketDashboardForm() {
    this.ticketDashboardSearchForm = this.formBuilder.group({
      ticketDashboardSearch: new FormControl(''),
    });

    this.reportsDashboardForm = this.formBuilder.group({
      fromDate: new FormControl(''),
      toDate: new FormControl(''),
      ticketCompletedAtFromDate: new FormControl(''),
      ticketCompletedAtToDate: new FormControl(''),
      state: new FormControl(''),
      dealerCode: new FormControl(''),
      assignTo: new FormControl(''),
      ticketStatusFilter: new FormControl(''),
      initiatedBy: new FormControl(''),
      deviceType: new FormControl(''),
      tatType: new FormControl(''),
    });
  }

  getFormDetails() {
    this.fromDate = this.reportsDashboardForm.get('fromDate')?.value;
    this.toDate = this.reportsDashboardForm.get('toDate')?.value;
    this.ticketCompletedAtFromDate = this.reportsDashboardForm.get(
      'ticketCompletedAtFromDate'
    )?.value;
    this.ticketCompletedAtToDate = this.reportsDashboardForm.get(
      'ticketCompletedAtToDate'
    )?.value;
    this.state = this.reportsDashboardForm.get('state')?.value;
    this.dealerCode = this.reportsDashboardForm.get('dealerCode')?.value;
    this.assignTo = this.reportsDashboardForm.get('assignTo')?.value;
    this.initiatedBy = this.reportsDashboardForm.get('initiatedBy')?.value;
    this.ticketStatusFilter =
      this.reportsDashboardForm.get('ticketStatusFilter')?.value;
    this.deviceType = this.reportsDashboardForm.get('deviceType')?.value;
    this.tatType = this.reportsDashboardForm.get('tatType')?.value;
    this.ticketDashboardSearch = this.ticketDashboardSearchForm.get(
      'ticketDashboardSearch'
    )?.value;
    if (this.fromDate) {
      const originalDate = new Date(this.fromDate);
      originalDate.setHours(0, 0, 0, 0);
      this.fromDate = originalDate.toISOString();
    } else {
      this.fromDate = '';
    }
    if (this.toDate) {
      const originalDate = new Date(this.toDate);
      originalDate.setHours(23, 59, 59, 999);
      this.toDate = originalDate.toISOString();
    } else {
      this.toDate = '';
    }
    if (this.ticketCompletedAtFromDate) {
      const originalDate = new Date(this.ticketCompletedAtFromDate);
      originalDate.setHours(0, 0, 0, 0);
      this.ticketCompletedAtFromDate = originalDate.toISOString();
    } else {
      this.ticketCompletedAtFromDate = '';
    }
    if (this.ticketCompletedAtToDate) {
      const originalDate = new Date(this.ticketCompletedAtToDate);
      originalDate.setHours(23, 59, 59, 999);
      this.ticketCompletedAtToDate = originalDate.toISOString();
    } else {
      this.ticketCompletedAtToDate = '';
    }
  }

  getAllCount() {
    this.getFormDetails();
    this._showSpinner();
    this.apiMicroservice
      .getAllVahanRegiCount(
        this.state,
        this.dealerCode,
        this.toDate,
        this.fromDate,
        this.assignTo,
        this.initiatedBy,
        this.ticketStatusFilter,
        this.deviceType,
        this.ticketDashboardSearch,
        '',
        this.ticketCompletedAtFromDate,
        this.ticketCompletedAtToDate,
        this.tatType
      )
      .subscribe((res) => {
        this._hideSpinner();
        this.allCount = res.data.all;
        this.completed = res.data.completed;
        this.cancelled = res.data.cancelled;
        this.inProgress = res.data.inProgress;
        this.onHold = res.data.onHold;
      });
  }

  fetchData(kpiClicked) {
    this.kpiCardSelected = kpiClicked;
    if (this.kpiCardSelected === 'ALL') {
      this.table_title = 'All';
    } else if (this.kpiCardSelected === 'COM') {
      this.table_title = 'Completed';
    } else if (this.kpiCardSelected === 'PRO') {
      this.table_title = 'In Progress';
    } else if (this.kpiCardSelected === 'CAN') {
      this.table_title = 'Cancelled';
    } else if (this.kpiCardSelected === 'HOLD') {
      this.table_title = 'On Hold';
    }

    setTimeout(() => {
      if (this.MyProp) {
        this.MyProp.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 100);

    this.page = 1;
    this.size = 10;
    this.fetchList();
  }

  onPageChange(event: number) {
    this.page = event;
    this.fetchList();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.fetchList();
  }

  onSearch(event: string) {
    this.page = 1;
    this.ticketDashboardSearchForm.controls['ticketDashboardSearch'].setValue(
      event
    );
    this.ticketDashboardSearch = event;
    this.fetchList();
    this.getAllCount();
  }

  getFilterResult() {
    this.getFormDetails();
    this.page = 1;
    this.size = 10;
    this.fetchData(this.kpiCardSelected);
    this.getAllCount();
    this.getTicketDashboardGraphData();
    this.closeModal();
  }

  clear() {
    this.reportsDashboardForm.reset();
    this.reportsDashboardForm.controls['dealerCode'].setValue('');
    this.reportsDashboardForm.controls['state'].setValue('');
    this.reportsDashboardForm.controls['fromDate'].setValue('');
    this.reportsDashboardForm.controls['toDate'].setValue('');
    this.reportsDashboardForm.controls['ticketCompletedAtFromDate'].setValue(
      ''
    );
    this.reportsDashboardForm.controls['ticketCompletedAtToDate'].setValue('');
    this.reportsDashboardForm.controls['assignTo'].setValue('');
    this.reportsDashboardForm.controls['ticketStatusFilter'].setValue('');
    this.reportsDashboardForm.controls['initiatedBy'].setValue('');
    this.reportsDashboardForm.controls['deviceType'].setValue('');
    this.reportsDashboardForm.controls['tatType'].setValue('');
    this.ticketDashboardSearchForm.controls['ticketDashboardSearch'].setValue(
      ''
    );
    this.kpiCardSelected = 'ALL';
    this.fetchData(this.kpiCardSelected);
    this.getAllCount();
    this.getTicketDashboardGraphData();
  }

  closeModal() {
    document
      ?.getElementById('filterDetails')
      ?.parentElement?.classList?.remove('active');
  }

  fetchList() {
    this._showSpinner();
    this.listOfData = [];
    this.getFormDetails();
    this.apiMicroservice
      .getAllMyActivity(
        this.page,
        this.size,
        '',
        this.fromDate,
        this.toDate,
        this.state,
        this.assignTo,
        this.ticketStatusFilter,
        this.dealerCode,
        this.initiatedBy,
        this.kpiCardSelected,
        this.ticketDashboardSearch,
        this.deviceType,
        this.ticketCompletedAtFromDate,
        this.ticketCompletedAtToDate,
        this.tatType
      )
      .subscribe((res) => {
        this._hideSpinner();
        this.totalLength = 0;
        if (res.status === true) {
          this.listOfData = res.data.data;
          this.totalLength = res.data.totalItems;
          this.apiMicroservice.openSnackbar('Fetched Successfully');
        }
      });
  }

  filterDropdownMenus() {
    document
      ?.getElementById('filterDetails')
      ?.parentElement?.classList.add('active');
    this.getAllDealers();
    this.getAssignedUser();
    this.getStateList();
    this.getStatusList();
  }

  getAllDealers() {
    this._showSpinner();
    this.apiMicroservice.getAllDealers(1, 10000, '').subscribe((res) => {
      this._hideSpinner();
      if (res.status) {
        this.listOfDealers = res.data.data;
        this.filteredListOfDealers = this.listOfDealers.slice();
        this.dealerCodeFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe((search: string) => {
            if (!search) {
              this.filteredListOfDealers = [...this.listOfDealers];
              return;
            }

            // Filter the list based on search value
            search = search.toLowerCase();
            this.filteredListOfDealers = this.listOfDealers.filter(
              (item: { posCode: string }) =>
                item.posCode.toLowerCase().includes(search)
            );
          });
      }
    });
  }

  getAssignedUser() {
    this._showSpinner();
    this.apiMicroservice.userAssignmentList('', '').subscribe((res) => {
      this._hideSpinner();
      this.listOfAssignedUser = res.data;
      this.filteredListOfAssignedUser = res.data;
      this.userNameFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe((search: string) => {
          if (!search) {
            this.filteredListOfAssignedUser = [...this.listOfAssignedUser];
            return;
          }

          // Filter the list based on search value
          search = search.toLowerCase();
          this.filteredListOfAssignedUser = this.listOfAssignedUser.filter(
            (item) =>
              item.firstName.toLowerCase().includes(search) ||
              item.lastName.toLowerCase().includes(search)
          );
        });
    });
  }

  getStateList() {
    this._showSpinner();
    this.apiMicroservice.getAllGovtServerList().subscribe((res) => {
      if (res.status) {
        this._hideSpinner();
        this.listOfState = res.data.map((element) => ({
          name: element.state,
          value: element.stateAbbreviation,
        }));
        this.filteredListOfState = this.listOfState.slice();
        this.stateNameFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe((search: string) => {
            if (!search) {
              this.filteredListOfState = [...this.listOfState];
              return;
            }

            // Filter the list based on search value
            search = search.toLowerCase();
            this.filteredListOfState = this.listOfState.filter((item) =>
              item.name.toLowerCase().includes(search)
            );
          });
      }
    });
  }

  getStatusList() {
    let kpiFilteredStatusList = this.listOfTicketStatus;

    const allowedCodes = this.kpiStatusMap[this.kpiCardSelected];

    if (allowedCodes) {
      kpiFilteredStatusList = this.listOfTicketStatus.filter((item) =>
        allowedCodes.includes(item.statusCode)
      );
    }

    this.filteredListOfTicketStatus = kpiFilteredStatusList.slice();

    this.ticketStatusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search: string) => {
        if (!search) {
          this.filteredListOfTicketStatus = kpiFilteredStatusList.slice();
          return;
        }

        search = search.toLowerCase();

        this.filteredListOfTicketStatus = kpiFilteredStatusList.filter(
          (item) =>
            item.status.toLowerCase().includes(search) ||
            item.statusCode.toLowerCase().includes(search)
        );
      });
  }

  downloadTATReport() {
    if (confirm('Do you want to download report?')) {
      alert('It will take time please wait.');

      this.getFormDetails();

      const email = this.apiMicroservice.decryptData(
        sessionStorage.getItem('email') || ''
      );
      // mark download in-progress and notify other tabs
      this.isDownloading = true;
      localStorage.setItem('downloadInProgress', 'true');

      this.apiMicroservice.openSnackbar(
        'Your file is being generated. Refreshing the page or logging out may interrupt the download.'
      );
      this.apiMicroservice
        .downloadTATReport(
          this.fromDate,
          this.toDate,
          this.state,
          this.assignTo,
          this.ticketStatusFilter,
          this.dealerCode,
          this.initiatedBy,
          this.kpiCardSelected,
          this.ticketDashboardSearch,
          this.deviceType,
          email,
          this.ticketCompletedAtFromDate,
          this.ticketCompletedAtToDate,
          this.tatType
        )
        .subscribe({
          next: (res) => {
            try {
              if (res?.status && res.fileDownloadUrl) {
                const link = document.createElement('a');
                link.href = res.fileDownloadUrl;
                link.download = ''; // let browser infer filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.apiMicroservice.openSnackbar('File ready for download');
              } else {
                this.apiMicroservice.openSnackbar(
                  res?.message || 'File URL not available'
                );
              }
            } finally {
              // clear in-progress state
              this.isDownloading = false;
              localStorage.setItem('downloadInProgress', 'false');
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            const example =
              ERROR.error.message ||
              'Download failed. Please contact server team.';
            this.apiMicroservice.openSnackbar(example);
            // clear in-progress state
            this.isDownloading = false;
            localStorage.setItem('downloadInProgress', 'false');
          },
        });
    }
  }

  getMonthName(month, year) {
    return new Date(year, month - 1).toLocaleString('default', {
      month: 'short',
    });
  }

  getTicketDashboardGraphData(): void {
    this._showSpinner();
    this.getFormDetails();
    this.apiMicroservice
      .fetchTicketDashboardGraph(
        '',
        this.fromDate,
        this.toDate,
        this.state,
        this.assignTo,
        this.ticketStatusFilter,
        this.dealerCode,
        this.initiatedBy,
        this.deviceType,
        this.ticketCompletedAtFromDate,
        this.ticketCompletedAtToDate,
        this.tatType
      )
      .subscribe({
        next: (res) => {
          if (res.status) {
            this.processMonthTicketDistribution(res.monthsTicketStats || []);
            this.processStateTicketDistribution(
              res.stateTicketDistribution || []
            );
            this.processUserTicketDistribution(
              res.userTicketDistribution || []
            );
            this.processDeviceModelDistribution(res.deviceModelWiseGraph || []);
            this.processTatBucketDistribution(res.tatBucketGraph || []);
            this.processTatHoldReasonDistribution(
              res.topHoldReasonsGraph || []
            );
            this._hideSpinner();
          }
        },
        error: (error) => {
          console.error('Error fetching ticket trend data:', error);
        },
      });
  }

  // Process API response and update chart
  processMonthTicketDistribution(data): void {
    if (!data || data.length === 0) {
      this.monthWiseChartData = { labels: [], datasets: [] };
      return;
    }

    const labels: string[] = [];

    const inProgress: number[] = [];
    const completed: number[] = [];
    const onHold: number[] = [];
    const cancelled: number[] = [];

    data.forEach((item) => {
      const monthName = this.getMonthName(item.month, item.year);

      labels.push(`${monthName} ${item.year}`);

      inProgress.push(item.inProgress || 0);
      completed.push(item.completed || 0);
      onHold.push(item.onHold || 0);
      cancelled.push(item.cancelled || 0);
    });

    this.monthWiseChartData = {
      labels,
      datasets: [
        {
          label: 'In Progress',
          data: inProgress,
          borderColor: '#3366CC',
          borderWidth: 2,
          backgroundColor: '#3366CC',
          pointBackgroundColor: '#3366CC',
          pointBorderColor: '#3366CC',
          tension: 0.4,
          fill: false,
          pointRadius: 3,
        },
        {
          label: 'Completed',
          data: completed,
          borderColor: '#4CAF50',
          borderWidth: 2,
          backgroundColor: '#4CAF50',
          pointBackgroundColor: '#4CAF50',
          pointBorderColor: '#4CAF50',
          tension: 0.4,
          fill: false,
          pointRadius: 3,
        },
        {
          label: 'On Hold',
          data: onHold,
          borderColor: '#F97316',
          borderWidth: 2,
          backgroundColor: '#F97316',
          pointBackgroundColor: '#F97316',
          pointBorderColor: '#F97316',
          tension: 0.4,
          fill: false,
          pointRadius: 3,
        },
        {
          label: 'Cancelled',
          data: cancelled,
          borderColor: '#F44336',
          borderWidth: 2,
          backgroundColor: '#F44336',
          pointBackgroundColor: '#F44336',
          pointBorderColor: '#F44336',
          tension: 0.4,
          fill: false,
          pointRadius: 3,
        },
      ],
    };
  }

  tatCategoryLabels: Record<string, string> = {
    LESS_THAN_4: 'Less Than 4 Hrs',
    LESS_THAN_10: 'Less Than 10 Hrs',
    MORE_THAN_10: 'More Than 10 Hrs',
    IN_PROGRESS: 'In Progress',
    ON_HOLD: 'On Hold',
    ON_HOLD_DUE_TO_RTO_APPROVAL: 'On Hold Due to RTO Approval',
    ON_HOLD_DUE_TO_SUSPENDED_OR_OTHER: 'On Hold Due to Suspended/Other',
  };

  // A readable label for the raw tatCategory enum shown in the list table.
  getTatCategoryLabel(category: string | undefined): string {
    if (!category) {
      return '--';
    }
    return this.tatCategoryLabels[category] || category;
  }

  // ms -> "2d 4h 10m", skipping zero units (always shows at least one unit).
  private formatTatDuration(ms: number | undefined): string {
    if (!ms || ms <= 0) {
      return '0m';
    }
    const totalMinutes = Math.round(ms / 60000);
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;
    const parts: string[] = [];
    if (days) parts.push(`${days}d`);
    if (hours) parts.push(`${hours}h`);
    if (minutes || parts.length === 0) parts.push(`${minutes}m`);
    return parts.join(' ');
  }

  // Full plain-language TAT breakdown for one ticket, shown in the info
  // popover next to the TAT category column - total/business/hold time,
  // the resolved category, and the actual hold history (why the clock
  // stopped, when, and for how long), not just the bucket it landed in.
  getTatBreakdownTooltip(item: {
    assignDate?: string | Date;
    ticketEndDate?: string | Date;
    tatAnalytics?: {
      totalTatMs?: number;
      totalHoldMs?: number;
      businessTatMs?: number;
      businessEffectiveTatMs?: number;
      tatCategory?: string;
      holds?: {
        reasonLabel?: string;
        reasonCode?: string;
        startTime?: string | Date;
        endTime?: string | Date;
        timeDifference?: number;
      }[];
      currentHold?: {
        reasonLabel?: string;
        reasonCode?: string;
        startTime?: string | Date;
      } | null;
    };
  }): string {
    const tat = item.tatAnalytics;
    if (!tat) {
      return 'No TAT data recorded for this ticket yet.';
    }

    const opened = item.assignDate
      ? new Date(item.assignDate).toLocaleString()
      : '--';
    const closed = item.ticketEndDate
      ? new Date(item.ticketEndDate).toLocaleString()
      : 'still open';

    const lines = [
      `Opened: ${opened}`,
      `Closed: ${closed}`,
      '',
      `Total time open: ${this.formatTatDuration(tat.totalTatMs)}`,
      `Time spent on hold: ${this.formatTatDuration(tat.totalHoldMs)}`,
      `Business-hours time: ${this.formatTatDuration(tat.businessTatMs)}`,
      `Business time excl. holds: ${this.formatTatDuration(tat.businessEffectiveTatMs)}`,
      '',
      `Category: ${this.getTatCategoryLabel(tat.tatCategory)}`,
    ];

    const holds = tat.holds || [];
    if (holds.length > 0 || tat.currentHold) {
      lines.push('', 'Hold history:');
      holds.forEach((hold) => {
        const start = hold.startTime
          ? new Date(hold.startTime).toLocaleString()
          : '--';
        const end = hold.endTime
          ? new Date(hold.endTime).toLocaleString()
          : '--';
        lines.push(
          `${hold.reasonLabel || hold.reasonCode || 'Hold'}: ${start} → ${end}  (${this.formatTatDuration(hold.timeDifference)})`
        );
      });
      if (tat.currentHold) {
        const since = tat.currentHold.startTime
          ? new Date(tat.currentHold.startTime).toLocaleString()
          : '--';
        lines.push(
          `Currently on hold: ${tat.currentHold.reasonLabel || tat.currentHold.reasonCode} (since ${since})`
        );
      }
    } else {
      lines.push('', 'No holds recorded — progressed without interruption.');
    }

    return lines.join('\n');
  }

  processTatBucketDistribution(data) {
    const countsByCategory: Record<string, number> = {};
    (data || []).forEach((item) => {
      countsByCategory[item._id] = item.count || 0;
    });

    // Always show every known bucket (defaulting to 0), plus any unexpected
    // category the API might return that isn't in the known label map.
    const categories = Array.from(
      new Set([
        ...Object.keys(this.tatCategoryLabels),
        ...Object.keys(countsByCategory),
      ])
    );

    this.tatBucketChartData = {
      labels: categories.map((key) => this.tatCategoryLabels[key] || key),
      datasets: [
        {
          label: 'Ticket Count',
          data: categories.map((key) => countsByCategory[key] || 0),
          backgroundColor: [
            '#3B82F6',
            '#22C55E',
            '#8B5CF6',
            '#EF4444',
            '#F59E0B',
            '#EC4899',
            '#14B8A6',
          ],
        },
      ],
    };
  }

  processTatHoldReasonDistribution(data) {
    if (!data || data.length === 0) {
      this.tatHoldReasonChartData = { labels: [], datasets: [] };
      return;
    }

    this.tatHoldReasonChartData = {
      labels: data.map((item) =>
        item._id ? item._id.replace(/^On Hold Due to\s*/i, '').trim() : ''
      ),
      datasets: [
        {
          label: 'Ticket Count',
          data: data.map((item) => item.ticketCount),
          backgroundColor: '#F59E0B',
          borderRadius: 4,
        },
      ],
    };
  }

  processStateTicketDistribution(data) {
    if (!data || data.length === 0) {
      this.stateChartData = { labels: [], datasets: [] };
      return;
    }

    const labels = data.map((item) => item.stateAbbreviation);

    this.stateChartData = {
      labels,

      datasets: [
        {
          label: 'In Progress',
          data: data.map((d) => d.inProgress || 0),
          backgroundColor: '#3B82F6',
          borderRadius: 4,
        },
        {
          label: 'Completed',
          data: data.map((d) => d.completed || 0),
          backgroundColor: '#22C55E',
          borderRadius: 4,
        },
        {
          label: 'On Hold',
          data: data.map((d) => d.onHold || 0),
          backgroundColor: '#F59E0B',
          borderRadius: 4,
        },
        {
          label: 'Cancelled',
          data: data.map((d) => d.cancelled || 0),
          backgroundColor: '#EF4444',
          borderRadius: 4,
        },
      ],
    };
  }

  processUserTicketDistribution(data) {
    if (!data || data.length === 0) {
      this.userPerformanceChartData = { labels: [], datasets: [] };
      return;
    }

    const labels = data.map((item) => item.userName);

    this.userPerformanceChartData = {
      labels,

      datasets: [
        {
          label: 'In Progress',
          data: data.map((d) => d.inProgress || 0),
          backgroundColor: '#3B82F6',
        },
        {
          label: 'Completed',
          data: data.map((d) => d.completed || 0),
          backgroundColor: '#22C55E',
        },
        {
          label: 'On Hold',
          data: data.map((d) => d.onHold || 0),
          backgroundColor: '#F59E0B',
        },
        {
          label: 'Cancelled',
          data: data.map((d) => d.cancelled || 0),
          backgroundColor: '#EF4444',
        },
      ],
    };
  }

  processDeviceModelDistribution(data) {
    if (!data || data.length === 0) {
      this.deviceModelChartData = { labels: [], datasets: [] };
      return;
    }
    this.deviceModelChartData = {
      labels: data.map((item) => item.deviceType),

      datasets: [
        {
          label: 'Device Count',

          data: data.map((item) => item.count || 0),

          backgroundColor: ['#5681d1', '#f76a23'],
        },
      ],
    };
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.apiMicroservice.back();
  }

  private _showSpinner() {
    if (this.spinnerCount++ === 0) this.spinner.show();
  }

  private _hideSpinner() {
    if (--this.spinnerCount === 0) this.spinner.hide();
  }
}
